import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-refurbished-program';

export default function Example() {
  return (
    <>
      <Head>
        <title>How the eBay Refurbished Program Works for Sellers</title>
        <meta
          name='description'
          content='Discover how the eBay Refurbished Program works for sellers and its benefits that may help you become a power seller!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-refurbished-program' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-refurbished-program' />
        <meta property='og:title' content='How the eBay Refurbished Program Works for Sellers' />
        <meta
          property='og:description'
          content='Discover how the eBay Refurbished Program works for sellers and its benefits that may help you become a power seller!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
